"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//import objAsArray from 'shared/utils/objAsArray';

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
  var educationLevels = _ref.data.educationLevels;

  return {
    educationLevels: educationLevels
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ProgramTypes/selectors.js
// module id = 1116
// module chunks = 0